<template>
  <span style="font-size: 16px">
    {{ `Запросить код повторно через ${timeLeftString || '...'}` }}
  </span>
</template>

<script>
import {isNullOrUndefined} from "@/plugins/object-helpers"

export default {
  name: "x-count-down-label",
  props: {
    expireTimestamp: Number,
  },
  data() {
    return {
      timeLeftString: null,
      timer: null,
    }
  },
  /**
   * Старт таймера при отображении компонента, если expireTimestamp был установлен ранее
   */
  mounted() {
    if (!isNullOrUndefined(this.expireTimestamp)) {
      this.startCountDown()
    }
  },
  /**
   * Остановка таймера при скрытии компонента
   */
  beforeDestroy() {
    clearInterval(this.timer)
  },
  watch: {
    expireTimestamp(val) {
      this.startCountDown()
    }
  },
  methods: {
    /**
     * Обработчик таймера обратного отсчета. Подготавливает строку для вывода
     */
    countDownHandler() {
      const timeLeft = this.expireTimestamp - Date.now()
      if (timeLeft > 0) {
        const timeLeftSeconds = parseInt(timeLeft / 1000)
        const minutes = parseInt(timeLeftSeconds / 60)
        const seconds = timeLeftSeconds % 60
        this.timeLeftString = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      } else {
        clearInterval(this.timer)
        this.$emit('timer-expired')
      }
    },
    /**
     * Старт таймера обратного отсчета. Запускаем один раз сразу после получения expireTimestamp, затем - каждую 1с
     */
    startCountDown() {
      this.countDownHandler()
      this.timer = setInterval(this.countDownHandler, 1000)
    },
  }
}
</script>

<style scoped>

</style>